module.exports = __webpack_public_path__ + "img/steak-1.f5c88cfb.png";